import { useParams } from 'quartz-routing/react-router';
import { useFullShort } from './shortContentQueries';
import { useVideoPlayerConfig } from '../video/videoHooks';
import { PLAYLIST_SEARCH_PARAM } from '../playlistContent/playlistContentConsts';
// @ts-expect-error Could not find a declaration file for module
import { useSearchParam } from '../../hooks/searchParamHooks';
export const useShortContentParams = () => {
  const {
    shortId,
    playlistNavigation
  } = useParams();
  const [[playlistIdParam]] = useSearchParam(PLAYLIST_SEARCH_PARAM);
  return {
    shortId: shortId ? Number(shortId) : undefined,
    playlistId: playlistIdParam ? Number(playlistIdParam) : undefined,
    playlistNavigation
  };
};
export const useShortVideo = ({
  shortId,
  skip
}) => {
  const {
    short
  } = useFullShort(shortId, skip);
  const {
    autoPlay,
    playSpeed
  } = useVideoPlayerConfig();
  if (!short) return null;
  const {
    reference,
    hubId,
    duration
  } = short;
  return {
    videoId: reference || '',
    autoPlay,
    playSpeed,
    creatorHubId: hubId,
    creatorRegion: short.contentHublet,
    businessObjectives: short.businessObjectives,
    useCases: short.useCases,
    videoDuration: duration,
    visibility: short.visibility
  };
};